import { render, staticRenderFns } from "./FilterSummaryItemTapirMd.vue?vue&type=template&id=62b76c52&"
import script from "./FilterSummaryItemTapirMd.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryItemTapirMd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports